import type {NavigationGuardNext, RouteRecordNormalized} from "vue-router"
import {$auth} from "@/plugins/auth"
import {ROUTES} from "@/router/paths"
import route from "@/plugins/route"

export default class Subscribed implements App.Middleware.Instance {
  async handle(
    to: RouteRecordNormalized,
    from: RouteRecordNormalized,
    next: App.Middleware.Caller,
    cancel: NavigationGuardNext
  ): Promise<void> {
    if ($auth.hasActiveSubscription) {
      return next(to, from, cancel)
    } else if (to.name !== ROUTES.MY_ACCOUNT) {
      return cancel(route(ROUTES.MY_ACCOUNT, {}, {tab: 'billing'}))
    }

    return next(to, from, cancel)
  }
}
